const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "Kies het juiste plan met eenvoudige & transparante prijzen",
  monthlyUppercase: "MAANDELIJKS",
  montly: "Maandelijks",
  free: "GRATIS",
  yearlyUppercase: "JAARLIJKS",
  yearly: "Jaarlijks",
  inService: "In Service",
  buyBtn: "Koop Nu",
  freeTips1: "Ondersteunt maximale bestandsgrootte van 20MB",
  freeTips2: "6 bestanden per dag",
  freeTips3: "Normale verwerkingssnelheid",
  freeTips4: "Normale download snelheid",
  freeTips5: "Achtergrond verwijderen van 1 pics per dag",
  freeTips52: "Achtergrond verwijderen van 1 pics per dag",
  freeTips6: "Toegang tot alle gratis tools",
  vipTips1: "Onbeperkte bestandsgrootte",
  vipTips2: "Onbeperkt aantal bestanden per dag",
  vipTips3: "Hogere downloadsnelheid",
  vipTips4: "Hogere verwerkingssnelheid",
  vipTips5: "Onbeperkt",
  vipTips6: "Onbeperkt verwijderen van achtergrondafbeeldingen per dag",
  vipTips7: "Toegang tot alle tools & premium functies",
  vipTips8: "Automatisch verlengen en op elk moment opzeggen.",
  vipTips9: "Geen video grootte en hoeveelheid limiet",
  vipTips10: "Verwijder beeld achtergronden zonder limieten",
  vipTips11: "Snellere videoverwerking en downloadsnelheid",
  vipTips12: "Toegang tot alle gratis gereedschap & premium functies",
  acceptTitle: "Wij accepteren",
  modalTitle: "Upgrade naar Pro om toegang te krijgen tot alle premium functies",
  total: "Totaal",
  enterCode: "Voer code in",
  SignUpToPurchaseBtn: "Meld u aan om te kopen",
  purchaseBtn: "Ga naar Kopen",
  saveTips: "Bespaar tot {{num}}%",
  discount: "Korting",
  purchaseTips: "Automatisch verlengen en op elk moment opzeggen.",
  tips: "Tips:",
  promoCodeInvalidTips: "Uw promotiecode is ongeldig",
};

export default purchase;
